<template>
  <div class="bug" :class="{blinking:isBlinking,'showBug':bugStatus}" @click="getBug">
    <img src="@/assets/img/icon76.png" alt="">
  </div>
  <!-- <div :class="$route.meta.fixed?'pageRotate180':'vh100'"  -->
  <div class="scroll" id="containerScroll"
    :class="['/culture/investment'].includes($route.path)?'pageRotate180': $route.meta.fixed || $route.query.fixed?'pageRotate180':'vh100'" :style="{background:bg?bg:'white',
    width:$route.meta.fixed || $route.query.fixed?height100+'px':'100%',
    height:$route.meta.fixed || $route.query.fixed?width100+'px':'100vh',
    marginTop: $route.meta.fixed || $route.query.fixed?top:'',
    marginLeft:$route.meta.fixed || $route.query.fixed?left:'auto',
    overflow: ['/shop/detail'].includes($route.path)?'scroll':''}" style="background-size:cover">
    <div style="clear:both" class="height44px"></div>
    <router-view v-slot="{ Component }">
      <keep-alive include="MyForum,Culture,MyLaw,Vote,MyJoin,Shop,Shopdetail,Money,Forums,OrderTab">
        <component :is="Component" />
      </keep-alive>
    </router-view>
  </div>
</template>
<script>
export default {
  name: 'App',
  data () {
    return {
      bugStatus: false,//动态类显示状态
      isBlinking: false,//闪烁状态
      bg: '',
      fixed: false,
      height100: window.innerHeight + 'px',
      top: -window.innerWidth / 2 - 44 + 'px',
      left: -window.innerHeight / 2 + 'px',
      width100: window.innerWidth + 'px'
    }
  },
  methods: {
    // 跳转bug提交页面
    getBug () {
      if (!this.bugStatus) {
        this.bugStatus = true
        this.showBugStatus = setInterval(() => {
          this.bugStatus = false
        }, 3000)
      } else {
        this.$router.push('/bug')

      }
    }
  },
  watch: {
    $route (v) {
      let { title, bg, fixed, auth } = v.meta;
      // let {title,bg,fixed} = v.meta;
      if (title) {
        document.title = title + '·雾森';
      }
      if (auth && !this.$store.state.loginInfo.token) {
        this.$router.replace({ path: '/login' });
      }
      this.bg = bg || '';
      this.fixed = fixed || false;
      if (['/culture/investment'].includes(v.path)) {
        let app = document.getElementById('app')
        app.style.width = 100 + 'vw'
        app.style.height = 100 + 'vh'
      } else {
        let app = document.getElementById('app')
        app.style.width = ''
        app.style.height = ''
      }
    }
  },
  mounted () {
    let height100 = window.innerHeight, width100 = window.innerWidth;
    if (height100 > width100) {
      this.height100 = height100;
      this.width100 = width100;
    } else {
      this.height100 = width100;
      this.width100 = height100;
    }
    this.left = - height100 / 2 + 'px'
    this.top = - width100 / 2 + 'px'

    if (this.$store.state.loginInfo.token && !this.$store.state.loginInfo.headPic) {
      this.ajax.post("users/getinfo").then(({ data }) => {
        data.headPic = data.head_pic;
        this.$store.state.loginInfo = { ...this.$store.state.loginInfo, ...data }
        localStorage.setItem("loginInfo", JSON.stringify(this.$store.state.loginInfo));
      })
    }



    // 设置每五分钟闪烁一次
    this.blinkingInterval = setInterval(() => {
      this.isBlinking = true
      setTimeout(() => {
        this.isBlinking = false
      }, 2000)
    }, 5 * 60 * 1000)
  },
  beforeUnmount () {
    clearInterval(this.blinkingInterval)
    clearInterval(this.showBugStatus)

  }
}
</script>
<style lang="scss">
.vh100 {
  min-height: calc(100vh - 44px)!important;
}
.unoverflow {
  overflow: unset;
}
@keyframes blink {
  0%{
    opacity: 1.0;
  }
  50%{
    opacity: 0;
  }
  100%{
    opacity: 1.0;
  }
}
.blinking{
  animation:  blink 1s infinite;
}

.bug{
  position: fixed;
  top: 100px;
  left: -10px;
  width: 25px;
  height: 25px;
  text-align: center;
  line-height: 25px;
  border-radius: 50%;
  z-index: 999;
}
.showBug{
  left: 0;
}
</style>
